<!-- 发表讨论 -->
<template>
  <div class="zlr-discuss-add">
    <h1>{{title}}</h1>
    <div class="zlr-discuss-add-con">
      <div class="zlr-discuss-add-left">
        <img :src="avatar"
             alt="">
      </div>
      <div class="zlr-discuss-add-right">
        <editor ref="analysisEditor"
                :cache=false
                v-model="discuss" />
        <div class="zlr-discuss-add-btn"
             v-show="$slots.default">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// less
import './discuss-add.less'
// components
import Editor from '_c/editor/editor'
export default {
  name: 'zlr-discuss-add',
  components: {
    Editor
  },
  props: {
    value: {
      default: ''
    },
    title: {
      default: ''
    },
    avatar: {
      required: true
    }
  },
  data () {
    return {
      discuss: ''
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    resetHtml () {
      this.$refs['analysisEditor'].setHtml('')
    }
  },
  watch: {
    discuss (newValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
